module.exports = __webpack_public_path__ + "static/media/twitter-container.0d82a6e7.svg";